import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder mb-0" }, "Payment Methods")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_new_card"
}
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = {
  id: "kt_customer_view_payment_method",
  class: "card-body pt-0"
}
const _hoisted_7 = {
  class: "py-0",
  "data-kt-customer-payment-method": "row"
}
const _hoisted_8 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_9 = {
  class: "d-flex align-items-center collapsible rotate collapsed",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_payment_method_1",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_payment_method_1"
}
const _hoisted_10 = { class: "me-3 rotate-90" }
const _hoisted_11 = { class: "svg-icon svg-icon-3" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<img src=\"media/svg/card-logos/mastercard.svg\" class=\"w-40px me-3\" alt=\"\"><div class=\"me-3\"><div class=\"d-flex align-items-center\"><div class=\"text-gray-800 fw-bolder\">Mastercard</div><div class=\"badge badge-light-primary ms-5\">Primary</div></div><div class=\"text-muted\">Expires Dec 2024</div></div>", 2)
const _hoisted_14 = { class: "d-flex my-3 ms-9" }
const _hoisted_15 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_new_card"
}
const _hoisted_16 = {
  "data-bs-toggle": "tooltip",
  "data-bs-trigger": "hover",
  title: "",
  "data-bs-original-title": "Edit"
}
const _hoisted_17 = { class: "svg-icon svg-icon-3" }
const _hoisted_18 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-kt-customer-payment-method": "delete",
  "data-bs-original-title": "Delete"
}
const _hoisted_19 = { class: "svg-icon svg-icon-3" }
const _hoisted_20 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary w-30px h-30px",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-bs-original-title": "More Options"
}
const _hoisted_21 = { class: "svg-icon svg-icon-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-150px py-3",
  "data-kt-menu": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "menu-link px-3",
      "data-kt-payment-mehtod-action": "set_as_primary"
    }, "Set as Primary")
  ])
], -1)
const _hoisted_23 = {
  id: "kt_customer_view_payment_method_1",
  class: "fs-6 ps-10 collapse",
  "data-bs-parent": "#kt_customer_view_payment_method",
  style: {}
}
const _hoisted_24 = { class: "d-flex flex-wrap py-5" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-equal me-5\"><table class=\"table table-flush fw-bold gy-1\"><tbody><tr><td class=\"text-muted min-w-125px w-125px\">Name</td><td class=\"text-gray-800\">Emma Smith</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Number</td><td class=\"text-gray-800\">**** 9916</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Expires</td><td class=\"text-gray-800\">12/2024</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Type</td><td class=\"text-gray-800\">Mastercard credit card</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Issuer</td><td class=\"text-gray-800\">VICBANK</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">ID</td><td class=\"text-gray-800\">id_4325df90sdf8</td></tr></tbody></table></div>", 1)
const _hoisted_26 = { class: "flex-equal" }
const _hoisted_27 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, " Billing address "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "AU")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Phone"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "No phone provided")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Email"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "text-gray-900 text-hover-primary"
    }, "e.smith@kpmg.com.au")
  ])
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Origin"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createTextVNode(" Australia "),
    /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-20px symbol-circle ms-2" }, [
      /*#__PURE__*/_createElementVNode("img", { src: "media/flags/australia.svg" })
    ])
  ])
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "CVC check", -1)
const _hoisted_33 = { class: "text-gray-800" }
const _hoisted_34 = { class: "svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_36 = {
  class: "py-0",
  "data-kt-customer-payment-method": "row"
}
const _hoisted_37 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_38 = {
  class: "d-flex align-items-center collapsible rotate collapsed",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_payment_method_2",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_payment_method_2"
}
const _hoisted_39 = { class: "me-3 rotate-90" }
const _hoisted_40 = { class: "svg-icon svg-icon-3" }
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<img src=\"media/svg/card-logos/visa.svg\" class=\"w-40px me-3\" alt=\"\"><div class=\"me-3\"><div class=\"d-flex align-items-center\"><div class=\"text-gray-800 fw-bolder\">Visa</div></div><div class=\"text-muted\">Expires Feb 2022</div></div>", 2)
const _hoisted_43 = { class: "d-flex my-3 ms-9" }
const _hoisted_44 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_new_card"
}
const _hoisted_45 = {
  "data-bs-toggle": "tooltip",
  "data-bs-trigger": "hover",
  title: "",
  "data-bs-original-title": "Edit"
}
const _hoisted_46 = { class: "svg-icon svg-icon-3" }
const _hoisted_47 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-kt-customer-payment-method": "delete",
  "data-bs-original-title": "Delete"
}
const _hoisted_48 = { class: "svg-icon svg-icon-3" }
const _hoisted_49 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary w-30px h-30px",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-bs-original-title": "More Options"
}
const _hoisted_50 = { class: "svg-icon svg-icon-3" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-150px py-3",
  "data-kt-menu": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "menu-link px-3",
      "data-kt-payment-mehtod-action": "set_as_primary"
    }, "Set as Primary")
  ])
], -1)
const _hoisted_52 = {
  id: "kt_customer_view_payment_method_2",
  class: "fs-6 ps-10 collapse",
  "data-bs-parent": "#kt_customer_view_payment_method",
  style: {}
}
const _hoisted_53 = { class: "d-flex flex-wrap py-5" }
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-equal me-5\"><table class=\"table table-flush fw-bold gy-1\"><tbody><tr><td class=\"text-muted min-w-125px w-125px\">Name</td><td class=\"text-gray-800\">Melody Macy</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Number</td><td class=\"text-gray-800\">**** 5459</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Expires</td><td class=\"text-gray-800\">02/2022</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Type</td><td class=\"text-gray-800\">Visa credit card</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Issuer</td><td class=\"text-gray-800\">ENBANK</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">ID</td><td class=\"text-gray-800\">id_w2r84jdy723</td></tr></tbody></table></div>", 1)
const _hoisted_55 = { class: "flex-equal" }
const _hoisted_56 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, " Billing address "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "UK")
], -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Phone"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "No phone provided")
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Email"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "text-gray-900 text-hover-primary"
    }, "melody@altbox.com")
  ])
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Origin"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createTextVNode(" United Kingdom "),
    /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-20px symbol-circle ms-2" }, [
      /*#__PURE__*/_createElementVNode("img", { src: "media/flags/united-kingdom.svg" })
    ])
  ])
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "CVC check", -1)
const _hoisted_62 = { class: "text-gray-800" }
const _hoisted_63 = { class: "svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_65 = {
  class: "py-0",
  "data-kt-customer-payment-method": "row"
}
const _hoisted_66 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_67 = {
  class: "d-flex align-items-center collapsible collapsed rotate",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_payment_method_3",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_payment_method_3"
}
const _hoisted_68 = { class: "me-3 rotate-90" }
const _hoisted_69 = { class: "svg-icon svg-icon-3" }
const _hoisted_70 = /*#__PURE__*/_createStaticVNode("<img src=\"media/svg/card-logos/american-express.svg\" class=\"w-40px me-3\" alt=\"\"><div class=\"me-3\"><div class=\"d-flex align-items-center\"><div class=\"text-gray-800 fw-bolder\">American Express</div><div class=\"badge badge-light-danger ms-5\">Expired</div></div><div class=\"text-muted\">Expires Aug 2021</div></div>", 2)
const _hoisted_72 = { class: "d-flex my-3 ms-9" }
const _hoisted_73 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_new_card"
}
const _hoisted_74 = {
  "data-bs-toggle": "tooltip",
  "data-bs-trigger": "hover",
  title: "",
  "data-bs-original-title": "Edit"
}
const _hoisted_75 = { class: "svg-icon svg-icon-3" }
const _hoisted_76 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-kt-customer-payment-method": "delete",
  "data-bs-original-title": "Delete"
}
const _hoisted_77 = { class: "svg-icon svg-icon-3" }
const _hoisted_78 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary w-30px h-30px",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-bs-original-title": "More Options"
}
const _hoisted_79 = { class: "svg-icon svg-icon-3" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-150px py-3",
  "data-kt-menu": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "menu-link px-3",
      "data-kt-payment-mehtod-action": "set_as_primary"
    }, "Set as Primary")
  ])
], -1)
const _hoisted_81 = {
  id: "kt_customer_view_payment_method_3",
  class: "collapse fs-6 ps-10",
  "data-bs-parent": "#kt_customer_view_payment_method"
}
const _hoisted_82 = { class: "d-flex flex-wrap py-5" }
const _hoisted_83 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-equal me-5\"><table class=\"table table-flush fw-bold gy-1\"><tbody><tr><td class=\"text-muted min-w-125px w-125px\">Name</td><td class=\"text-gray-800\">Rakib Hasan</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Number</td><td class=\"text-gray-800\">**** 5029</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Expires</td><td class=\"text-gray-800\">08/2021</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Type</td><td class=\"text-gray-800\">American express credit card</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">Issuer</td><td class=\"text-gray-800\">USABANK</td></tr><tr><td class=\"text-muted min-w-125px w-125px\">ID</td><td class=\"text-gray-800\">id_89457jcje63</td></tr></tbody></table></div>", 1)
const _hoisted_84 = { class: "flex-equal" }
const _hoisted_85 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, " Billing address "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "US")
], -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Phone"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, "No phone provided")
], -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Email"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "text-gray-900 text-hover-primary"
    }, "max@kt.com")
  ])
], -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Origin"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800" }, [
    /*#__PURE__*/_createTextVNode(" United States of America "),
    /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-20px symbol-circle ms-2" }, [
      /*#__PURE__*/_createElementVNode("img", { src: "media/flags/united-states.svg" })
    ])
  ])
], -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "CVC check", -1)
const _hoisted_91 = { class: "text-gray-800" }
const _hoisted_92 = { class: "svg-icon svg-icon-2 svg-icon-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card pt-4 ${_ctx.cardClasses}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen035.svg" })
          ]),
          _createTextVNode(" Add new method")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr071.svg" })
              ])
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("a", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ])
            ]),
            _createElementVNode("a", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
              ])
            ]),
            _createElementVNode("a", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
              ])
            ]),
            _hoisted_22
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("table", _hoisted_27, [
                _createElementVNode("tbody", null, [
                  _hoisted_28,
                  _hoisted_29,
                  _hoisted_30,
                  _hoisted_31,
                  _createElementVNode("tr", null, [
                    _hoisted_32,
                    _createElementVNode("td", _hoisted_33, [
                      _createTextVNode(" Passed "),
                      _createElementVNode("span", _hoisted_34, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen043.svg" })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_35,
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("span", _hoisted_40, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr071.svg" })
              ])
            ]),
            _hoisted_41
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("a", _hoisted_44, [
              _createElementVNode("span", _hoisted_45, [
                _createElementVNode("span", _hoisted_46, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ])
            ]),
            _createElementVNode("a", _hoisted_47, [
              _createElementVNode("span", _hoisted_48, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
              ])
            ]),
            _createElementVNode("a", _hoisted_49, [
              _createElementVNode("span", _hoisted_50, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
              ])
            ]),
            _hoisted_51
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("table", _hoisted_56, [
                _createElementVNode("tbody", null, [
                  _hoisted_57,
                  _hoisted_58,
                  _hoisted_59,
                  _hoisted_60,
                  _createElementVNode("tr", null, [
                    _hoisted_61,
                    _createElementVNode("td", _hoisted_62, [
                      _createTextVNode(" Passed "),
                      _createElementVNode("span", _hoisted_63, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_64,
      _createElementVNode("div", _hoisted_65, [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("span", _hoisted_69, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr071.svg" })
              ])
            ]),
            _hoisted_70
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("a", _hoisted_73, [
              _createElementVNode("span", _hoisted_74, [
                _createElementVNode("span", _hoisted_75, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ])
            ]),
            _createElementVNode("a", _hoisted_76, [
              _createElementVNode("span", _hoisted_77, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
              ])
            ]),
            _createElementVNode("a", _hoisted_78, [
              _createElementVNode("span", _hoisted_79, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
              ])
            ]),
            _hoisted_80
          ])
        ]),
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _hoisted_83,
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("table", _hoisted_85, [
                _createElementVNode("tbody", null, [
                  _hoisted_86,
                  _hoisted_87,
                  _hoisted_88,
                  _hoisted_89,
                  _createElementVNode("tr", null, [
                    _hoisted_90,
                    _createElementVNode("td", _hoisted_91, [
                      _createTextVNode(" Failed "),
                      _createElementVNode("span", _hoisted_92, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}